import React, { useState } from "react";

import toast from "react-hot-toast";
import axios from "axios";

import ActionsBtn from "./ActionsBtn";
import EditTask from "./EditTask";
import DeleteTask from "./DeleteTask";
import { API } from "../../global";

const TasksListCommentBox = (props) => {
  const { logItem, handleButtonClick, fetchTasks } = props;
  const [showModal, setShowModal] = useState(false);
  const [showDelModal, setShowDelModal] = useState(false);

  const handleDelete = async () => {
    const taskDetails = {
      taskId: logItem._id
    }
    const config = {
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${localStorage.getItem("auth_token")}`
      }
    };
    const res = await axios.post(`${API}/schedule-task/delete`, JSON.stringify(taskDetails), config);
    if (res.data.success) {
      toast.success("Task deleted successfully");
      setShowDelModal(false);
      fetchTasks();
    } else {
      toast.error(res.data.error.msg);
      setShowDelModal(false);
    }
  }

  const handleCancel = () => {
    setShowDelModal(false);
  }

  return (
    <>
      <div className="relative w-100 text-xs text-[#868A97]">
        <label className="absolute top-1 left-3 bg-white  px-1">Comments</label>
        <textarea
          className="border border-[#DCDCDC] h-[80px] w-[300px] resize-none focus:outline-none text-xs rounded-lg mt-3 p-3"
          value={logItem.comments}
        />
      </div>
      {/* buttons */}
      <div className="flex flex-col gap-1 px-2">
        <ActionsBtn
          btnName={logItem.btn}
          onClick={() => handleButtonClick(logItem.id)}
        />
        <ActionsBtn btnName="Edit" onClick={() => setShowModal(!showModal)} />
        <ActionsBtn
          btnName="Delete"
          onClick={() => setShowDelModal(true)}
        />
      </div>
      {showModal && (
        <EditTask
          showModal={showModal}
          setShowModal={setShowModal}
          logItem={logItem}
          fetchTasks={fetchTasks}
        />
      )}

      {showDelModal && (
        <DeleteTask
          showDelModal={showDelModal}
          setShowDelModal={setShowDelModal}
          handleConfirm={handleDelete}
          handleCancel={handleCancel}
        />
      )}
    </>
  );
};

export default TasksListCommentBox;
